// extracted by mini-css-extract-plugin
export default {"pageLayout":"Vendors_pageLayout__z3yV2"};